/**
 * SignalingConnectionState
 * ------------------------
 *
 * Lifecycle of the underlying WebSocket connection.
 *
 * DISCONNECTED:
 *   No active transport.
 *
 * CONNECTING:
 *   WebSocket is being established.
 *
 * CONNECTED:
 *   WebSocket is open, but HELLO/auth not yet completed.
 *
 * AUTHENTICATED:
 *   HELLO succeeded, WELCOME received.
 *
 * READY:
 *   Fully ready to send/receive signaling (post-auth steady state).
 *
 * RECONNECTING:
 *   Transport dropped and client is attempting to reconnect/resume.
 *
 * ERROR:
 *   Terminal or semi-terminal failure state.
 */
export const SIGNALING_CONNECTION_STATE = {
    DISCONNECTED: "DISCONNECTED",
    CONNECTING: "CONNECTING",
    CONNECTED: "CONNECTED",
    AUTHENTICATED: "AUTHENTICATED",
    READY: "READY",
    RECONNECTING: "RECONNECTING",
    ERROR: "ERROR",
};
/**
 * ResumeState
 * -----------
 *
 * Represents the outcome/state of session resume.
 *
 * NONE:
 *   No resume attempt has been made.
 *
 * ATTEMPTING:
 *   Client is attempting resume via HELLO.resume.
 *
 * SUCCESS:
 *   Resume succeeded (WELCOME.resume.ok === true).
 *
 * FAILED:
 *   Resume was attempted but failed (server created new session).
 */
export const RESUME_STATE = {
    NONE: "NONE",
    ATTEMPTING: "ATTEMPTING",
    SUCCESS: "SUCCESS",
    FAILED: "FAILED",
};
